import {
  styled,
  Dialog,
  dialogClasses,
  DialogContent,
  DialogActions,
} from '@mui/material';

export const DialogImportPartnerCompaniesFromCSVContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    width: '100%',
  },
});

export const DialogImportPartnerCompaniesFromCSVContent = styled(DialogContent)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  }),
);

export const DialogImportPartnerCompaniesFromCSVActions = styled(DialogActions)(
  {
    justifyContent: 'space-between',
  },
);
